import { inject, injectable } from 'inversify'

import { Notification } from '@domain/notification'

import { NotificationsStore } from '@infrastructure/stores/notifications/notifications-store'

@injectable()
export class NotificationsManager {
  constructor(
    @inject(NotificationsStore)
    private notificationsStore: NotificationsStore,
  ) {}

  public notify(notification: Omit<Notification, 'id'>) {
    const id = Date.now()

    this.notificationsStore.getState().show({
      id,
      ...notification,
    })
  }
}
